import { useLang } from '../../../i18n/LangContext';

export default function About() {
  const { t } = useLang();

  return (
    <section id="about" className="relative py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent">
            {t('about_title')}
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] mx-auto"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="space-y-6">
            <p className="text-lg text-gray-300 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: t('about_p1').replace(/<b>/g, '<strong class="text-[#d4af37]">').replace(/<\/b>/g, '</strong>') }}
            />
            <p className="text-lg text-gray-300 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: t('about_p2').replace(/<b>/g, '<strong class="text-[#d4af37]">').replace(/<\/b>/g, '</strong>') }}
            />
            <p className="text-lg text-gray-300 leading-relaxed"
              dangerouslySetInnerHTML={{ __html: t('about_p3').replace(/<b>/g, '<strong class="text-[#d4af37]">').replace(/<\/b>/g, '</strong>') }}
            />
          </div>

          <div className="space-y-4">
            {[
              { icon: 'ri-line-chart-line', titleKey: 'about_skill1_title', descKey: 'about_skill1_desc' },
              { icon: 'ri-global-line',     titleKey: 'about_skill2_title', descKey: 'about_skill2_desc' },
              { icon: 'ri-shield-check-line', titleKey: 'about_skill3_title', descKey: 'about_skill3_desc' },
            ].map((skill, i) => (
              <div key={i} className="bg-gradient-to-br from-[#1a1f35] to-[#0a0e1a] p-6 rounded-xl border border-[#d4af37]/20 hover:border-[#d4af37]/50 transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-[#d4af37]/10 rounded-lg">
                    <i className={`${skill.icon} text-2xl text-[#d4af37]`}></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-[#d4af37] mb-2">{t(skill.titleKey)}</h3>
                    <p className="text-gray-400">{t(skill.descKey)}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
